
import Moment from 'moment';

const routeData1 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: 'San Francisco',
        airportCode: 'SFO',
        date: new Moment('2018-05-22 07'),
        anchor: 'left',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-119.839937, 34.427],
      },
      properties: {
        description: 'Santa Barbara',
        airportCode: 'SBA',
        date: new Moment('2018-05-22 15'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

const routeData1_return = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-119.839937, 34.427],
      },
      properties: {
        description: 'Santa Barbara',
        airportCode: 'SBA',
        date: new Moment('2018-05-22 15'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: 'San Francisco',
        airportCode: 'SFO',
        date: new Moment('2018-05-22 07'),
        anchor: 'left',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

const slideData = [routeData1, routeData1_return ]

export default slideData;



// WEBPACK FOOTER //
// ./src/tripData2.js